import React, { Component } from "react";
import moment from "moment";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";

import { Typography, Grid } from "@material-ui/core";

// import ScreenWrapper from "../../../components/ScreenWrapper";

import { getCurrency } from "../../common/util";

class BillListScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false,
      currency: "",
      kot: null,
      all_time: null,
      today: null,
      yesterday: null,
    };
  }

  componentDidMount() {
    this.getData();
    const currency = getCurrency(this.props.selectedHotelId.currency) + " ";
    this.setState({ currency });
  }

  getData = async () => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.getDashboardData
    );
    if (status == "error") {
      return this.props.okDialog(message);
    }

    const { kot, all_time, today, yesterday } = data;

    this.setState({ kot, all_time, today, yesterday }, () =>
      this.setState({ mounted: true })
    );
  };



  currency = (val) => {
    return this.state.currency + val;
  };

  Tab = ({ title, value, type = "label" }) => {
    if (type == "amt") {
      value = this.currency(value.toFixed(2));
    }

    return (
      <Grid
        item
        // xs={12}
        // sm={6}
        // md={4}
        style={{
          padding: 10,
          backgroundColor: "#16232c",
          borderRadius: 5,
          margin: 5,
        }}
      >
        <span
          variant="h3"
          align="center"
          color={value == 0 ? "secondary" : "#fec756"}
        >
          {value}
        </span>
        <span variant="h5" align="center">
          {title}
        </span>
      </Grid>
    );
  };

  Section = ({ title }) => {
    return (
      <span variant="h4" style={{ marginTop: 10, marginBottom: 5 }}>
        {title}
      </span>
    );
  };

  render() {
    const { kot, all_time, today, yesterday, mounted } = this.state;
    return (
      <div>
        {/* appbar with left hamburger icon */}
        {/* <AppBar type="back" title="Dashboard" subTitle={this.props.selectedHotel.hotel_name} /> */}
        {mounted && (
          <Grid container spacing={1} style={{ margin: "10px 0" }}>
            <Grid item xs={12}>
              {/* --------------------------- Today -------------------------------- */}
              <this.Section title="Today" />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Dine-in revenue"
                value={today?.dinein_revenue}
                type="amt"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Dine-in orders" value={today?.total_dinein} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Takeaway revenue"
                value={today?.takeaway_revenue}
                type="amt"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Today takeaway" value={today?.total_takeaway} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Table Bookings" value={today?.table_booking} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Total Orders" value={today?.total_orders} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Hall revenue"
                value={today?.hall_revenue}
                type="amt"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Hall bookings" value={today?.hall_booking} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Total Revenue"
                value={today?.total_revenue}
                type="amt"
              />
            </Grid>

            {/* -------------------- Yesterday --------------------------- */}
            <Grid item xs={12}>
              <this.Section title="Yesterday" />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Dine-in revenue"
                value={yesterday?.dinein_revenue}
                type="amt"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Dine-in orders"
                value={yesterday?.total_dinein}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Takeaway revenue"
                value={yesterday?.takeaway_revenue}
                type="amt"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Today takeaway"
                value={yesterday?.total_takeaway}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Table Bookings"
                value={yesterday?.table_booking}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Total Orders" value={yesterday?.total_orders} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Hall revenue"
                value={yesterday?.hall_revenue}
                type="amt"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Hall bookings" value={yesterday?.hall_booking} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Total Revenue"
                value={yesterday?.total_revenue}
                type="amt"
              />
            </Grid>

            {/* ----------------------- All Time ------------------------- */}
            <Grid item xs={12}>
              <this.Section title="All Time" />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Dine-in revenue"
                value={all_time?.dinein_revenue}
                type="amt"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Dine-in orders" value={all_time?.total_dinein} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Takeaway revenue"
                value={all_time?.takeaway_revenue}
                type="amt"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Today takeaway"
                value={all_time?.total_takeaway}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Table Bookings"
                value={all_time?.table_booking}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Total Orders" value={all_time?.total_orders} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Hall revenue"
                value={all_time?.hall_revenue}
                type="amt"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Hall bookings" value={all_time?.hall_booking} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab
                title="Total Revenue"
                value={all_time?.total_revenue}
                type="amt"
              />
            </Grid>

            {/* ----------------------- KOT ---------------------- */}
            <Grid item xs={12}>
              <this.Section title="KOT" />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Today" value={kot?.today_total_kot} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Yesterday" value={kot?.yesterday_total_kot} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <this.Tab title="Total" value={kot?.total_kot} />
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}

export default redux(BillListScreen);
